import React from "react";
import { CreditCard, User, Home, Phone, Mail } from "lucide-react";

const BillingForm = ({ 
  formData, 
  handleInputChange, 
  handleSubmit, 
  isSubmitting, 
  hasCartItems, 
  finalTotal, 
  isProcessingPayment 
}) => {
  const isLoading = isSubmitting || isProcessingPayment;

  return (
    <div className="lg:w-2/3 bg-white p-6 rounded-sm border border-gray-200 shadow-sm">
      <h2
        className="text-2xl text-[#333333] mb-4"
        style={{ fontFamily: "serif" }}
      >
        Billing Information
      </h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm text-gray-600 mb-1">
            <User className="w-4 h-4 inline mr-2 text-[#D4AF37]" />
            Full Name
          </label>
          <input
            type="text"
            name="fullName"
            onChange={handleInputChange}
            className="w-full py-2 px-4 rounded-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm"
            placeholder="Full Name"
            required
            disabled={isLoading}
          />
        </div>

        <div>
          <label className="block text-sm text-gray-600 mb-1">
            <Mail className="w-4 h-4 inline mr-2 text-[#D4AF37]" />
            Email
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            className="w-full py-2 px-4 rounded-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm"
            placeholder="john.doe@example.com"
            required
            disabled={isLoading}
          />
        </div>

        <div>
          <label className="block text-sm text-gray-600 mb-1">
            <Phone className="w-4 h-4 inline mr-2 text-[#D4AF37]" />
            Phone Number
          </label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            className="w-full py-2 px-4 rounded-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm"
            placeholder="+91 123-456-7890"
            required
            disabled={isLoading}
          />
        </div>

        <div>
          <label className="block text-sm text-gray-600 mb-1">
            <Home className="w-4 h-4 inline mr-2 text-[#D4AF37]" />
            Billing Address
          </label>
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            className="w-full py-2 px-4 rounded-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm"
            placeholder="123 Elegance Street"
            required
            disabled={isLoading}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm text-gray-600 mb-1">
              City
            </label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
              className="w-full py-2 px-4 rounded-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm"
              placeholder="Kochi"
              required
              disabled={isLoading}
            />
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">
              State
            </label>
            <input
              type="text"
              name="state"
              value={formData.state}
              onChange={handleInputChange}
              className="w-full py-2 px-4 rounded-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm"
              placeholder="Karnataka"
              required
              disabled={isLoading}
            />
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">
              ZIP Code
            </label>
            <input
              type="text"
              name="zip"
              value={formData.zip}
              onChange={handleInputChange}
              className="w-full py-2 px-4 rounded-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm"
              placeholder="560001"
              required
              disabled={isLoading}
            />
          </div>
        </div>

        <div className="mt-4">
          <label className="flex items-center text-sm text-gray-600">
            <input
              type="checkbox"
              name="sameAsBilling"
              checked={formData.sameAsBilling}
              onChange={handleInputChange}
              className="mr-2"
              disabled={isLoading}
            />
            Shipping address same as billing
          </label>
        </div>

        {!formData.sameAsBilling && (
          <div className="space-y-4 mt-4">
            <h3
              className="text-lg text-[#333333]"
              style={{ fontFamily: "serif" }}
            >
              Shipping Address
            </h3>
            <div>
              <label className="block text-sm text-gray-600 mb-1">
                <Home className="w-4 h-4 inline mr-2 text-[#D4AF37]" />
                Shipping Address
              </label>
              <input
                type="text"
                name="shippingAddress"
                value={formData.shippingAddress}
                onChange={handleInputChange}
                className="w-full py-2 px-4 rounded-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm"
                required={!formData.sameAsBilling}
                disabled={isLoading}
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm text-gray-600 mb-1">
                  City
                </label>
                <input
                  type="text"
                  name="shippingCity"
                  value={formData.shippingCity}
                  placeholder="Kochi"
                  onChange={handleInputChange}
                  className="w-full py-2 px-4 rounded-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm"
                  required={!formData.sameAsBilling}
                  disabled={isLoading}
                />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">
                  State
                </label>
                <input
                  type="text"
                  name="shippingState"
                  value={formData.shippingState}
                  onChange={handleInputChange}
                  className="w-full py-2 px-4 rounded-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm"
                  placeholder="kerala"
                  required={!formData.sameAsBilling}
                  disabled={isLoading}
                />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">
                  ZIP Code
                </label>
                <input
                  type="text"
                  name="shippingZip"
                  value={formData.shippingZip}
                  onChange={handleInputChange}
                  className="w-full py-2 px-4 rounded-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#D4AF37] text-sm"
                  placeholder="560001"
                  required={!formData.sameAsBilling}
                  disabled={isLoading}
                />
              </div>
            </div>
          </div>
        )}

        <div className="mt-6 p-4 bg-gray-50 border border-gray-200 rounded-sm">
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium text-gray-700">Total Amount:</span>
            <span className="text-lg font-semibold text-[#D4AF37]">₹{finalTotal.toFixed(2)}</span>
          </div>
        </div>

        <button
          type="submit"
          className={`w-full py-2 px-4 rounded-sm text-sm font-medium transition-all duration-200 flex items-center justify-center mt-6 ${
            !hasCartItems || isLoading
              ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
              : 'bg-[#D4AF37] text-black hover:bg-[#C19B2E]'
          }`}
          disabled={!hasCartItems || isLoading}
        >
          {isProcessingPayment ? (
            <>
              <span className="animate-spin mr-2">⏳</span>
              Redirecting to Payment...
            </>
          ) : isSubmitting ? (
            <>
              <span className="animate-spin mr-2">⏳</span>
              Creating Order...
            </>
          ) : (
            <>
              <CreditCard className="w-4 h-4 mr-2" />
              Proceed to Payment
            </>
          )}
        </button>

        {isLoading && (
          <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-sm">
            <p className="text-sm text-blue-700">
              {isProcessingPayment 
                ? "Please wait while we redirect you to the payment gateway..." 
                : "Creating your order..."}
            </p>
          </div>
        )}
      </form>
    </div>
  );
};

export default BillingForm;